<template>
    <div>
        <SmartBreadcrumbs
            type="InertiaLink"
            :pages="[
                {
                    name: group.name,
                    href: meta.links.group_show,
                },
                {
                    name: $t('messages.export_grades_from_tags'),
                    href: null,
                },
            ]"
        >
            <template v-slot:corner>
                <div>
                    <ActivityMenuOptions>
                        <InertiaLink
                            v-for="otherGroup in meta.links.otherGroups"
                            :href="otherGroup.url"
                            :key="otherGroup.url"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                        >
                            {{ otherGroup.text }}
                        </InertiaLink>
                    </ActivityMenuOptions>
                </div>
            </template>
        </SmartBreadcrumbs>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <div>
            <!--            @submit.prevent="filter"-->
            <form :action="meta.links.index" method="GET" @submit.prevent="filter">
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-2">
                        <div class="">
                            <FormLabel :value="$t('messages.difficulty')" for="difficulty_in" />
                            <SlideOverCheckboxInput v-model="form.difficulty_in" :options="options.difficulties" />
                            <FormError :value="form.errors.difficulty_in" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-2">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.date_from')" for="date_from" />
                            <FormInput
                                id="date_from"
                                v-model="form.date_from"
                                type="date"
                                name="date_from"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.date_from" class="mt-2" />
                        </div>
                    </div>
                    <div class="sm:col-span-2">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.date_to')" for="date_to" />
                            <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1" />
                            <FormError :value="form.errors.date_to" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.activity_mode')" for="modes" />
                            <SlideOverCheckboxInput v-model="form.modes" :options="options.modes" :int-keys="false" />
                            <FormError :value="form.errors.modes" class="mt-2" />
                        </div>
                    </div>
                </div>

                <input type="hidden" name="modes[]" v-for="mode in form.modes" :key="mode" :value="mode" />
                <input type="hidden" name="tag_ids[]" v-for="tag in form.tag_ids" :key="tag" :value="tag" />

                <div class="flex justify-end gap-2 mt-5">
                    <AppButton
                        element="a"
                        :href="meta.links.store"
                        :processing="form.processing"
                        v-if="filters.tag_ids"
                        :disabled="form.isDirty"
                        >{{ $t('messages.download') }}</AppButton
                    >
                    <SubmitFormButton :button-text="$t('messages.filter')" :processing="form.processing" />
                </div>
            </form>
        </div>
        <form action="" @submit.prevent="filter" v-if="filters.subject_id">
            <AppWell v-if="options.tags.blocks.length" class="mt-3">
                <PageSectionCollapsible class="mt-5">
                    <template v-slot:title> {{ $tc('messages.tags', 2) }} ({{ form.tag_ids.length }}) </template>
                    <QuestionTagSelectorByBlock v-model="form.tag_ids" :blocks="options.tags.blocks" />

                    <template v-slot:closed>
                        <div class="mt-3">
                            <AppCard>
                                <div class="p-2 flex flex-wrap gap-2">
                                    <BadgePill color="indigo" v-for="tag in selectedTags" :key="tag.id">
                                        {{ tag.name }}
                                    </BadgePill>
                                </div>
                            </AppCard>
                        </div>
                    </template>
                </PageSectionCollapsible>
            </AppWell>
        </form>
    </div>

    <TagLevelReachedGroupTable :table="table" v-if="table" />
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import SubmitFormButton from '../../../../Activities/Subactivities/SubmitFormButton.vue';
import SmartBreadcrumbs from '../../../../../../components/SmartBreadcrumbs.vue';
import FormLabel from '../../../../../../components/Forms/FormLabel.vue';
import SlideOverCheckboxInput from '../../../../../../components/Forms/SlideOverCheckboxInput.vue';
import FormError from '../../../../../../components/Forms/FormError.vue';
import PageSectionCollapsible from '../../../../../../Shared/PageSectionCollapsible.vue';
import QuestionTagSelectorByBlock from '../../../../../../components/QuestionTagSelectorByBlock.vue';
import AppWell from '../../../../../../Shared/AppWell.vue';
import AppCard from '../../../../../../Shared/AppCard.vue';
import BadgePill from '../../../../../../components/BadgePill.vue';
import TagLevelReachedGroupTable from '../../../../../../components/TagLevelReachedGroupTable.vue';
import FormInput from '../../../../../../components/Forms/FormInput.vue';

export default {
    components: {
        FormInput,
        BadgePill,
        AppCard,
        AppWell,
        QuestionTagSelectorByBlock,
        PageSectionCollapsible,
        FormError,
        SlideOverCheckboxInput,
        FormLabel,
        SmartBreadcrumbs,
        SubmitFormButton,
        ActivityMenuOptions,
        AppButton,
        EmptyState,
        IconCircleCheckFilled,
        TagLevelReachedGroupTable,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'options', 'filters', 'group', 'table', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
                with_expected_level: this.filters.with_expected_level,
                tag_ids: this.filters.tag_ids.map((id) => +id),
                modes: this.filters.modes,
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
                difficulty_in: this.filters.difficulty_in,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
            // this.form.post(this.meta.links.store);
        },
    },
    computed: {
        selectedTags() {
            return this.options.tags.blocks.flatMap((b) => b.tags).filter((t) => this.form.tag_ids.includes(t.id));
        },
    },
};
</script>
